import Images from "./Images";
import getStyles from "./styles";
import SecondaryTables from "./SecondaryTables";
import { formatTime } from "../../functions";
import type { IUserModalProps } from "../../types";
import { Box, Toolbar, Typography } from "@mui/material";

export default function _UserModal(props: IUserModalProps) {
  const { selectedUser, images } = props;

  const styles = getStyles();

  const imgSize = images?.document || images?.selfieRef ? 6 : 12;
  const height = window.screen.height;

  return (
    <Box sx={styles.root}>
      {selectedUser ? (
        <>
          <Toolbar sx={{ justifyContent: "space-between" }}>
            <Typography variant="h6" component="h2">
              Verification type: {selectedUser.UserInfo.verificationType}
            </Typography>

            <Typography variant="h6" component="h2">
              Created at: {formatTime(selectedUser.UserInfo.createdAt)}
            </Typography>

            <Typography variant="h6" component="h2">
              Registration number: {selectedUser.registrationNumber}
            </Typography>

            <Typography variant="h6" component="h2">
              PANEEM date of birth: {formatTime(selectedUser.birthDate)}
            </Typography>
          </Toolbar>

          <Toolbar sx={{ justifyContent: "center" }}>
            <Typography variant="h6" component="h2">
              Rejection cause: {selectedUser.UserInfo.rejectionCause ? selectedUser.UserInfo.rejectionCause : "None"}
            </Typography>
          </Toolbar>

          <SecondaryTables user={selectedUser} />
        </>
      ) : null}

      {images ? <Images imgHeight={height * 0.7} images={images} imgSize={imgSize} imgControl={true} /> : null}
    </Box>
  );
}
